
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()

    export class RewardsDetailsDialog extends Common.GridEditorDialog<RewardsDetailsRow> {
        protected getFormKey() { return RewardsDetailsForm.formKey; }
        //protected getIdProperty() { return RewardsDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return RewardsDetailsRow.localTextPrefix; }
        //protected getService() { return RewardsDetailsService.baseUrl; }
        protected getDeletePermission() { return RewardsDetailsRow.deletePermission; }
        protected getInsertPermission() { return RewardsDetailsRow.insertPermission; }
        protected getUpdatePermission() { return RewardsDetailsRow.updatePermission; }

        protected form = new RewardsDetailsForm(this.idPrefix);


        constructor() {
            super();

            this.form.ProductTypeId.changeSelect2(e => {
                switch (this.form.ProductTypeId.value) {
                    case '11':
                        q.hideField(this.form.CategoryId);
                        this.form.SubCategoryId.cascadeField = "CategoryId";
                        this.form.SubCategoryId.cascadeValue = "124";
                        break;
                    case '12':
                        q.hideField(this.form.CategoryId);
                        this.form.SubCategoryId.cascadeField = "CategoryId";
                        this.form.SubCategoryId.cascadeValue = "125";
                        break;
                    case '5':
                    case '6':
                    case '7':
                    case '9':
                        q.hideField(this.form.CategoryId);
                        q.hideField(this.form.SubCategoryId);
                        this.form.CategoryId.value = "";
                        this.form.SubCategoryId.value = "";
                        break;
                    case '1':
                    case '2':
                    case '3':
                    case '4':
                        q.showField(this.form.CategoryId);
                        q.showField(this.form.SubCategoryId);
                        break;
                }
            });

            this.form.CategoryId.changeSelect2(e => {
                this.form.SubCategoryId.cascadeField = "CategoryId";
                this.form.SubCategoryId.cascadeValue = this.form.CategoryId.value;

            });

          
        }

        onDialogOpen() {
            super.onDialogOpen();
            this.element.attr('style', 'width:620px');
        }

    }
}

